<template>
	<modal
		@cancel="$emit('cancel')"
		:loading="loading"
		v-if="storeDetails"
	>
		<div class="flex flex-between">
			<div class="sd-details">
				<div class="bold">
					<h2>
						<a :href="`/stores/${storeDetails.urlAlias}`" v-focus>
							{{ storeDetails.cityAlias }}
							{{ storeDetails.state }}
						</a>
					</h2>
					<div class="light-blue">
						<i class="fa fa-check"></i> My Local Store
					</div>
					<div class="store-address">
						<span>
							{{ storeDetails.name }}
							<br />
						</span>
						<span>
							{{ storeDetails.address1 }}
							<br />
						</span>
						<span>
							{{ storeDetails.city }},
							{{ storeDetails.state }}
							{{ storeDetails.zip }}
						</span>
					</div>
					<div clas="store-phone">
						<a :href="`tel:+1${storeDetails.phone}`">
							{{ storeDetails.phone }}
						</a>
					</div>
				</div>
				<div>
					<div v-for="h in storeHours" :key="h.day" class="store-hours">
						{{ h.day }} to {{ h.hours }}
					</div>
					<a class="link-blue sd-store-link" :href="`/stores/${storeDetails.urlAlias}`">
						View Store Page
					</a>
				</div>
				<ui-button
					:href="storeLink"
					target="_blank"
					rel="noopener"
				>
					Get Directions
				</ui-button>
			</div>
			<div class="google-map-container">
				<iframe
					v-if="googleApiKey"
					class="google-map"
					allowfullscreen=""
					:src="`//www.google.com/maps/embed/v1/place?q=place_id%3a${storeDetails.googlePlaceID}&amp;key=${googleApiKey}`"
				></iframe>
			</div>
		</div>
	</modal>
</template>

<script>
import focus from '../../directives/focus';
import Modal from '../../components/Modal.vue';
export default {
	name: 'StoreDetailsModal',
	props: {
		loading: Boolean,
		storeDetails: Object,
	},
	components: { Modal },
	directives: {
		'focus': focus
	},
	computed: {
		googleApiKey() {
			return this.$store.state.googleApiKey;
		},
		storeHours() {
			return !this.storeDetails.hours || this.storeDetails.comingSoon
				? null : this.convertHoursToArray(this.storeDetails.hours);
		},
		autoHours() {
			return !this.storeDetails.autoHours || this.storeDetails.comingSoon
				? null : this.convertHoursToArray(this.storeDetails.autoHours);
		},
		storeLink() {
			// NOTE: we need the place id and the address to ensure the stores can be found as expected on android maps.
			return `https://www.google.com/maps/search/?api=1&query_place_id=${this.storeDetails.googlePlaceID}&query=${encodeURIComponent(this.storeDetails.address1)},${encodeURIComponent(this.storeDetails.city)},${this.storeDetails.state}`;
		}
	},
	methods: {
		convertHoursToArray(hours) {
			const arr = [];
			if (!hours) return arr;
			for (const day in hours) {
				if (!hours.hasOwnProperty(day)) continue;
				arr.push({ day, hours: hours[day] });
			}
			return arr;
		},
	}
};
</script>

<style lang="less" scoped>
@import "../../../less/_variables.less";
.store-hours {
	margin-top: 15px;
	p {
		margin: 0;
		margin-top: 10px;
		padding: 0;
	}
}
.auto-hours {
	margin-top: 15px;
}
.store-address {
	margin: 15px 0 .3em 0;
	line-height: 1.3em;
	span {
		margin-top: 10px;
	}
}
.red-btn {
	margin-top: 10px;
}
.store-phone {
	margin-top: 15px;
}
.google-map-container {
	position: relative;
	overflow: hidden;
	flex: 1;
	min-height: 200px;
	.google-map {
		border: 0;
		height: 100%;
		right: 0;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}
}
.sd-details {
	min-width: 300px;
	margin-right: 15px;
}
.sd-store-link {
	display: block;
	font-weight: bold;
	margin: 10px 0;
}
@media screen and (max-width: @phablet) {
	.flex-between {
		justify-content: center;
		flex-direction: column;
		text-align: center;
	}
	.google-map {
		margin-top: 10px;
	}
	.sd-details {
		margin-right: 0;
		display: flex;
		flex-direction: column;
		min-width: auto;
		align-items: center;
	}
}
</style>
